import { userConstants } from "../constants/login.constants";

function generateMFAQR(state = {
  loading: false,
}, action) {
  switch (action.type) {
    case userConstants.GENERATEMFAQR_REQUEST:
      return {
        loading: true
      };
    case userConstants.GENERATEMFAQR_SUCCESS:
      return {
        items: action.data,
        loading: false,
      };
    case userConstants.GENERATEMFAQR_FAILURE:
      return {
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export default generateMFAQR;